import React from 'react';
import { IWhereClause } from '../proxy/DataServiceEntities.g';

interface IWhereQueryBuilderProps {
    where: IWhereClause[];
    updateWhere: (where: IWhereClause[]) => void;
}

const operators = ['=', '!=', '<', '>', '<=', '>=', 'LIKE'];

export const WhereQueryBuilder: React.FC<IWhereQueryBuilderProps> = ({ where, updateWhere }) => {
    const addWhereClause = () => {
        updateWhere([
            ...where,
            {
                Column: '',
                Operator: '=',
                Value: '',
                IsString: true,
                Conjunction: ''
            }
        ]);
    };

    const updateClause = (index: number, updates: Partial<IWhereClause>) => {
        updateWhere(
            where.map((clause, clauseIndex) => {
                if (clauseIndex !== index) {
                    return clause;
                }

                return {
                    ...clause,
                    ...updates
                };
            })
        );
    };

    const removeClause = (index: number) => {
        updateWhere(where.filter((_, clauseIndex) => clauseIndex !== index));
    };

    const clearClauses = () => {
        updateWhere([]);
    };

    return (
        <div className='table-browser-where'>
            <div className='table-browser-where__header'>
                <div>
                    <h2 className='table-browser-controls__section-title'>Filters</h2>
                    <p className='table-browser-controls__section-description'>
                        Add server-side filters to narrow the result set before pagination.
                    </p>
                </div>

                <button className='table-browser-controls__secondary-button' type='button' onClick={addWhereClause}>
                    Add Filter
                </button>
            </div>

            {where.length > 0 && (
                <div className='table-browser-where__rows'>
                    {where.map((clause, index) => (
                        <div className='table-browser-where__row' key={index}>
                            {index > 0 && (
                                <select
                                    className='table-browser-controls__select table-browser-where__conjunction'
                                    value={clause.Conjunction || 'AND'}
                                    onChange={e => updateClause(index, { Conjunction: e.target.value })}
                                >
                                    <option value='AND'>AND</option>
                                    <option value='OR'>OR</option>
                                </select>
                            )}

                            {index === 0 && <div className='table-browser-where__first-spacer' />}

                            <input
                                className='table-browser-controls__input'
                                type='text'
                                placeholder='Column'
                                value={clause.Column || ''}
                                onChange={e => updateClause(index, { Column: e.target.value })}
                            />

                            <select
                                className='table-browser-controls__select table-browser-where__operator'
                                value={clause.Operator || '='}
                                onChange={e => updateClause(index, { Operator: e.target.value })}
                            >
                                {operators.map(operator => (
                                    <option value={operator} key={operator}>
                                        {operator}
                                    </option>
                                ))}
                            </select>

                            <input
                                className='table-browser-controls__input'
                                type='text'
                                placeholder='Value'
                                value={clause.Value || ''}
                                onChange={e => updateClause(index, { Value: e.target.value })}
                            />

                            <label className='table-browser-where__string-check'>
                                <input
                                    type='checkbox'
                                    checked={!!clause.IsString}
                                    onChange={e => updateClause(index, { IsString: e.target.checked })}
                                />
                                String
                            </label>

                            <button
                                className='table-browser-where__remove-button'
                                type='button'
                                onClick={() => removeClause(index)}
                                aria-label='Remove filter'
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {where.length > 0 && (
                <div className='table-browser-where__footer'>
                    <button className='table-browser-where__clear-button' type='button' onClick={clearClauses}>
                        Clear filters
                    </button>
                </div>
            )}
        </div>
    );
};
